import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './Tag.module.css.mjs';
import { tagVariantClasses, tagSizeClasses } from './Tag.utils.mjs';

const Tag = polymorphicFactory(
  (props, ref) => {
    const { component = "div", label, size = "small", variant = "default", className, ...rest } = props;
    const classNames = clsx("kohler-tag-root", className, variant && tagVariantClasses[variant], classes.root);
    return /* @__PURE__ */ React.createElement(Box, { className: classNames, component, ref, ...rest }, /* @__PURE__ */ React.createElement("small", { className: clsx(size && tagSizeClasses[size]) }, label));
  }
);

export { Tag };
